import { render, staticRenderFns } from "./RightsManagement.vue?vue&type=template&id=3cd4fdca"
import script from "./RightsManagement.vue?vue&type=script&lang=js"
export * from "./RightsManagement.vue?vue&type=script&lang=js"
import style0 from "./RightsManagement.vue?vue&type=style&index=0&id=3cd4fdca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports